'use client';

import { useAppShell } from '@/components/layout/app-shell';
import { mainNavigation, userNavigation } from '@/components/layout/constants/navigation-constants';
import { Sidebar, SidebarContent, SidebarRail, SidebarSeparator } from '@/components/ui/sidebar';
import { useChromePathname } from '@/shared/components/providers/chrome-pathname';
import { AI_CHATS_PATTERN } from '@/shared/lib/chrome/route-classes';
import { AiChatsSidebar } from './ai-chats-sidebar';
import { NavMain } from './nav-main';
import { NavUser } from './nav-user';
import { NavWhatsNew } from './nav-whats-new';

export function AppSidebar({ collapsible, ...props }: React.ComponentProps<typeof Sidebar>) {
  const { isImmersive } = useAppShell();
  const resolvedCollapsible = collapsible ?? (isImmersive ? 'offcanvas' : 'icon');
  // Null at prerender/first render → default nav; on /ai the data-contextual
  // CSS guard hides it until this resolves and the sidebar morphs into Chats
  // (same frame + rail, like the studio contextual sidebars).
  const pathname = useChromePathname();

  if (pathname !== null && AI_CHATS_PATTERN.test(pathname)) {
    return (
      <Sidebar collapsible={resolvedCollapsible} {...props}>
        <AiChatsSidebar />
        <SidebarRail />
      </Sidebar>
    );
  }

  return (
    <Sidebar collapsible={resolvedCollapsible} {...props}>
      <SidebarContent>
        <NavMain items={mainNavigation} />
        <SidebarSeparator />
        <NavUser items={userNavigation} />
      </SidebarContent>

      <NavWhatsNew />

      <SidebarRail />
    </Sidebar>
  );
}
